import React from "react";
import './Dashboard.css';
import { DtoTwilioParticipantProps } from "../../core/dto/dashboard.dto";
import ParticipantTracks from "./ParticipantTracks";

const Participant = ({ keys, participant, muteval, classNames, isLocalParticipant }: DtoTwilioParticipantProps) => {

    const enableScreenShare: boolean = false;

    return (
        <>
            <ParticipantTracks
                participant={participant}
                videoOnly
                enableScreenShare={enableScreenShare}
                isLocalParticipant={isLocalParticipant}
                classNames={classNames}
            />
        </>
    )
}

export default Participant;